import { render, staticRenderFns } from "./decoration3.vue?vue&type=template&id=6c072ae1&scoped=true"
import script from "./decoration3.vue?vue&type=script&lang=js"
export * from "./decoration3.vue?vue&type=script&lang=js"
import style0 from "./decoration3.vue?vue&type=style&index=0&id=6c072ae1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c072ae1",
  null
  
)

export default component.exports